export const HomepageHKTypeformIsShownKey = "scmp-homepage-hk-typeform-is-shown";

export const TypeformId = "FuWfZ0N0";
